/**
 * Benchmark identities and their synthetic terminals.
 *
 * The OPERATIONAL benchmark — the excess-return baseline — is SPY,
 * unconditionally (plan §6.2f). That claim is about `getBenchmarkSeries` and
 * `xret` only, and QQQ below does not weaken it: QQQ is a comparison path on
 * the OHLC route (ADR-0045), never a second excess-return denominator.
 *
 * Neither is a universe member or a snapshot code. The port serves SPY's
 * `PriceSeries` so excess return can be derived from existing series payloads
 * (issue #82) without putting `xret` on `Security`.
 */
import { asTicker } from '@meridian/contracts';

export const BENCHMARK_SYMBOL = 'SPY';
export const BENCHMARK_TICKER = asTicker(BENCHMARK_SYMBOL);
/** Synthetic last close; live mode uses vendor adj_close. */
export const BENCHMARK_PRICE = 500;

/** Hop 9: QQQ is a distinct synthetic path, not a second envelope of SPY. */
export const QQQ_BENCHMARK_SYMBOL = 'QQQ';
export const QQQ_BENCHMARK_TICKER = asTicker(QQQ_BENCHMARK_SYMBOL);
/** Distinct terminal so a flat SPY and a flat QQQ still cannot collide. */
export const QQQ_BENCHMARK_PRICE = 400;
